/**
 * Today, in India, as an ISO date.
 *
 * A ledger date is a *day*, and which day it is depends on where the person is (`FEAT-011 §3.3`). The
 * server does the same arithmetic for the same reason (`IndiaTime`), and the two have to agree or an entry
 * recorded at 11pm is filed under yesterday.
 *
 * A fixed offset rather than a time zone: IST is UTC+05:30 and has had no daylight saving since 1945, so
 * there is nothing for a tz database to tell us. If this product ever serves a second time zone, this is
 * where that starts and it will need a per-user zone rather than a different constant.
 */
export function todayInIndia(): string {
  const shifted = new Date(Date.now() + 330 * 60_000);

  return shifted.toISOString().slice(0, 10);
}
